/* 

Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.

*/

import { useState, useEffect, useCallback } from 'react';
import axiosCall from '../../services/axios';
import useAbortController from './useAbortController';
import { useAuthContext } from '../../contexts/AuthContext';

const useGetEftBankAcctTypeQid = () => {
  const { get } = useAbortController();
  const { token } = useAuthContext();

  const [eftBankAcctTypeQidInfo, setEftBankAcctTypeQidInfo] = useState([]);
  const [eftBankAcctTypeQidStatus, setEftBankAcctTypeQidStatus] = useState('done');

  const getEftBankAcctTypeQidInfo = useCallback(async () => {
    if (!token) return;
    const controller = get();
    const config = { signal: controller.signal };
    const headers = {
      'Session-Token': token,
    };

    try {
      setEftBankAcctTypeQidStatus('loading');
      let response = await axiosCall({ url: 'live/master/qid/MASZ_CD.015/list', method: 'get' }, config, headers);
      setEftBankAcctTypeQidInfo(response);
      setEftBankAcctTypeQidStatus('done');
    } catch (e) {
      if (e.code !== 'ERR_CANCELED') {
        console.error('Unable to load eft bank account type options: ' + e);
        setEftBankAcctTypeQidStatus('error');
      }
    }
  }, [get, token]);

  useEffect(() => {
    getEftBankAcctTypeQidInfo();
  }, [getEftBankAcctTypeQidInfo]);

  return {
    eftBankAcctTypeQidInfo,
    eftBankAcctTypeQidStatus,
  };
};

export default useGetEftBankAcctTypeQid;
